import React from 'react';

const HomeLoan = () => {
    return(<h1>Home Loan</h1>);
}

export default HomeLoan;